/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import $ from 'jquery';
window.$ = window.jQuery = $;

import * as Sentry from "@sentry/browser";
import configureSentry from "../lib/raven";
import boot           from "../lib/boot";

import axios from 'axios';

$(function() {
  configureSentry();
  configureAxios(axios);

  try {
    boot.init()
  } catch(e) {
    Sentry.captureException(e);
  }
});

const configureAxios = (axios) => {
  axios.defaults.headers.common["X-CSRF-Token"] = document.getElementsByName("csrf-token")[0].getAttribute("content")
  axios.defaults.headers.common["Accept"] = "application/json"
}
